export enum InstanceType {
    EFP = 'efp',
    LEXIS = 'lexis',
}
